<script>
export default {
    page() {
        const title = 'Trending Mixes'
        const description = 'The most-played DJ mixes on FRISKY right now.'
        const image = `${import.meta.env.VITE_CLIENT_URL}/frisky-social-share-image.png`
        const canonicalUrl = `https://frisky.fm${this.$route.path}`
        return {
            title,
            link: [{ rel: 'canonical', vmid: 'canonical', href: canonicalUrl }],
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },
                { property: 'og:image', vmid: 'og:image', content: image },
                { property: 'og:type', vmid: 'og:type', content: 'website' },
                { property: 'og:url', vmid: 'og:url', content: canonicalUrl },
                { property: 'og:site_name', vmid: 'og:site_name', content: 'FRISKY' },

                { name: 'twitter:card', vmid: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', vmid: 'twitter:title', content: title },
                { name: 'twitter:description', vmid: 'twitter:description', content: description },
                { name: 'twitter:image', vmid: 'twitter:image', content: image },
                { name: 'twitter:url', vmid: 'twitter:url', content: canonicalUrl },
            ],
        }
    },
}
</script>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from '@composables/use-store'
import DataLayer from '@services/data-layer/index'
import MixGridBlock from '@components/mix-grid-block'

const LIMIT = 12
const BOTTOM_OFFSET_RATIO = 3

const store = useStore()

const mixes = ref([])
const offset = ref(0)
const isFull = ref(false)

const scroll = computed(() => store.state.appearance.scroll)

function loadMixes(from) {
    DataLayer.mixes.getTrending(LIMIT, from).then(response => {
        if (!response.body.length) {
            isFull.value = true
        } else {
            mixes.value.push(...response.body)
        }
    })
}

watch(scroll, () => {
    if (isFull.value) return

    const bottomOfWindow =
        scroll.value + window.innerHeight >=
        store.state.appearance.scrollChild.offsetHeight - window.innerHeight / BOTTOM_OFFSET_RATIO

    if (bottomOfWindow) {
        offset.value += LIMIT
        loadMixes(offset.value)
    }
})

onMounted(() => {
    loadMixes(offset.value)
})
</script>

<template>
    <BaseSection
        v-if="mixes && mixes.length"
        padded
    >
        <MixGridBlock :mixes="mixes" />
    </BaseSection>
</template>
